import { Dispatch } from 'redux';
import { AxiosResponse } from 'axios';
import { getPrice } from './payment.service';
import { getSortedQuestionByProjectId } from './question.service';
import http from '../utils/http';
import { IApplicationState } from '../reducers';
import config from '../config';
import { Audience, PanelType, Project, VIEW_MODE } from '@nexxt/common/types';
import { checkProjectHealth } from './project.service';
const { api } = config;

export function getAudienceByProjectID(projectID: string) {
    return async (dispatch, getState: () => IApplicationState) => {
        const url = `${api.endpoints.project}/${projectID}/audience`;
        const response: AxiosResponse<any> = await http.get(url);
        // add dispatch to add to current queue; or use state from current file

        await dispatch(getPrice({ projectID }));
        return response.data;
    };
}

export function saveAudience(
    projectID: string,
    quotas: Audience,
    disablePanel = false
) {
    return async (dispatch, getState: () => IApplicationState) => {
        const queryParams = disablePanel ? '?disablePanel' : '';

        //DELETE THIS
        const updatedAudienceRule = quotas.builtInAudienceRules.filter(
            (rule) => true
            // rule.selectedQuestion.label !== 'Age'
        );
        const updatedQuotas = {
            ...quotas,
            builtInAudienceRules: updatedAudienceRule
        };
        //DELETE THIS

        const url = `${api.endpoints.project}/${projectID}/audience${queryParams}`;
        const response: AxiosResponse<any> = await http.put(
            url,
            updatedQuotas,
            {}
        );
        // add dispatch to add to current queue; or use state from current file

        await dispatch(getPrice({ projectID }));
        await dispatch(getSortedQuestionByProjectId(Number(projectID)));
        dispatch(checkProjectHealth(Number(projectID)));
        return response.data;
    };
}

export async function updatePanelProject(
    project: Project,
    settings: {
        sampleSize: boolean;
    }
) {
    const url = `${api.endpoints.dynata}/${project.id}/update`;
    const resposne = await http.post(url, {
        totalSampleSize:
            settings.sampleSize &&
            project.panelSettings.dynata.price.promisedCount
    });

    return resposne.data;
}
